const colors = {
  good: "#0C9D61", // Green for good
  moderate: "#92D050", // Light green for moderate
  yellow: "#FFAD0D", // Yellow for moderate
  warning: "#ffd686", // Warning yellow
  poor: "#E62225", // Red for poor
  veryPoor: "#8a1416", // Dark red for very poor
};

export const chartColors = [
  "#FFDD82", // Light Yellow
  "#47B881", // Green
  "#F7A47A", // Light Orange
  "#4D7479", //Dusty Teal
  "#98C6CF", // Light Blue
  "#1F8297", // Dark Cyan
  "#0F4B57", // Dark Slate Blue
  "#166c7d", // Dark Teal
  "#5B98A4", // Slate Blue
  "#8AB5BE", // Soft Blue-Green
  "#B9D2D8", // Pale Cyan
  "#E9F3F5", // Very Light Cyan
  "#8AA4A7",
  "#26575D",
  "#F64C4C", // Red
];

export const chartColor1 = [
  "#4D7479", //Dusty Teal
  "#98C6CF", // Light Blue
  "#1F8297", // Dark Cyan
  "#0F4B57", // Dark Slate Blue
  "#166c7d", // Dark Teal
  "#5B98A4", // Slate Blue
];

export const scoreColors = [
  colors.good,
  colors.moderate,
  colors.yellow,
  colors.warning,
  colors.poor,
  colors.veryPoor,
];

export const legendColors = [colors.good, colors.yellow, colors.poor];

export const scoreRangeColor = [colors.poor, colors.yellow, colors.good];

export default colors;
